import React, { useState, useEffect } from "react";
import PatientDataService from "../services/patient.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { iconMap } from '../utils/iconMap';
import Carousel from 'react-bootstrap/Carousel';
import { useAuth0 } from '@auth0/auth0-react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const HomePat = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  
  const [state, setState] = useState({
    trdv: [],
    showModalRdvCancel: false,
    idrdv: '',
    medecin: '',
    structure: '',
    dateplagerdv: '',
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    weekDay2: {"1":"Dim","2":"Lun","3":"Mar","4":"Mer","5":"Jeu","6":"Ven","7":"Sam"},
    months: {"01":"Janvier","02":"Février","03":"Mars","04":"Avril","05":"Mai","06":"Juin","07":"Juillet","08":"Août","09":"Septembre","10":"Octobre","11":"Novembre","12":"Décembre"} 
  });

  const getPatRdv = async () => {
    try {
      const response = await PatientDataService.patrdv(user.email);
      setState(prev => ({
        ...prev,
        trdv: response.data
      }));
    } catch (e) {
      console.log(e);
    }
  };

  // Fonction annuler rdv 
  const handleShowRdvCancel = (idrdv, medecin, structure, dateplagerdv) => {
    setState(prev => ({
      ...prev,
      idrdv: idrdv,
      medecin: medecin,
      structure: structure,
      dateplagerdv: dateplagerdv,
      showModalRdvCancel: true
    }));
  };

  const handleCloseRdvCancel = () => {
    setState(prev => ({
      ...prev,
      showModalRdvCancel: false
    }));
  };

  const handleSubmitRdvCancel = async (event) => {
    event.preventDefault();
    try {
      await PatientDataService.patientRdvCancel(user.email, state.idrdv);
      getPatRdv();
      handleCloseRdvCancel();
    } catch (e) {
      console.log(e);
    }
  };

  // Méthode pour rendre la cellule de statut
  const renderStatutCell = (appointment) => {
    const statutLibelle = appointment.statut_rdv.split("_")[1];
    const statutStyle = appointment.statut_rdv.split("_")[0];
    const statutIcone = appointment.statut_rdv.split("_")[2];
    const statutTime = appointment.statut_rdv.split("_")[3];
    
    switch (statutLibelle) {
      case 'Manqué':
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase()}>{statutLibelle}</span>
          </td>
        );
      case 'En attente':
        return (
          <td className={statutStyle}>
            <div className="dropdown" title={"Rendez-vous " + statutLibelle.toLowerCase()}>
              <button style={{ color: 'inherit', textDecoration: 'none', padding: 0 }} className="btn btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <FontAwesomeIcon icon={iconMap[statutIcone]} /> {statutLibelle}
              </button>
              <ul className="dropdown-menu">
                <li key={appointment.id + '_mark_done'}>
                  <button 
                    className="dropdown-item" 
                    type="button" 
                    onClick={() => handleShowRdvCancel(
                      appointment.id, 
                      appointment.titre+' '+appointment.nom+' '+appointment.prenom, 
                      appointment.libelle_structure, 
                      'Rendez-vous du '+appointment.drdv+' entre '+appointment.hdeb+' et '+appointment.hfin
                    )}
                  >
                    Annuler ce rendez-vous
                  </button>
                </li>
              </ul>
            </div>
          </td>
        );
      default:
        return (
          <td className={statutStyle}>
            <FontAwesomeIcon icon={iconMap[statutIcone]} />{' '}
            <span title={"Rendez-vous " + statutLibelle.toLowerCase() + (statutTime ? " le " + statutTime : '')}>
              {statutLibelle}
            </span>
          </td>
        );
    }
  };

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email"
        });
        
        // Configurer le token pour axios
        const http = require("../http-common").default;
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        getPatRdv();
      } catch (error) {
        console.error('Erreur récupération token:', error);
      }
    };

    initializeComponent();
  }, [getAccessTokenSilently, user]);

  const { trdv, weekDay, weekDay2, months, showModalRdvCancel, medecin, structure, dateplagerdv } = state;

  return (
    <div className="col-md-12 mx-auto">
      <Modal show={showModalRdvCancel} onHide={handleCloseRdvCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Annuler ce rendez-vous</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <input type="text" className="form-control" value={medecin} readOnly/>
          </div>
          <div className="mb-3">
            <input type="text" className="form-control" value={structure} readOnly/>
          </div>
          <div className="mb-3">
            <input type="text" className="form-control" value={dateplagerdv} readOnly/>
          </div>
          <p className="text-danger" align="center">Voulez-vous annuler ce rendez-vous ?<br/>Cette action est irréversible!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleSubmitRdvCancel}>
            Valider
          </Button>
          <Button variant="secondary" onClick={handleCloseRdvCancel}>
            Annuler
          </Button>
        </Modal.Footer>
      </Modal>
      <table style={{width:"100%"}}>
        <tbody>
          <tr style={{backgroundColor:"#6f42c1"}}>
            <td style={{padding:"10px"}}>
              <table style={{color:"white"}}>
                <tbody>
                  <tr>
                    <td style={{padding:"5px"}}>
                      <FontAwesomeIcon icon={solid('calendar-days')} size="2x"/>
                    </td>
                    <td style={{padding:"5px"}}>
                      <span style={{fontSize:"1.5rem"}} className="lead"><b>Liste des rendez-vous (vue patient)</b></span><br/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr> 
        </tbody>
      </table>
      <div className="col-md-12 mx-auto" style={{padding:"10px"}}>
        <table className="table table-hover table-striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Plage</th>
              <th>Lieu</th>
              <th>Médecin</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {trdv && trdv.map((appointment, index) => {
              return (
                <tr key={index}>
                  <td>{appointment.drdv}</td>
                  <td>{appointment.hdeb+' - '+appointment.hfin}</td>
                  <td>{appointment.libelle_structure}</td>
                  <td>{appointment.titre+' '+appointment.nom+' '+appointment.prenom}</td>
                  {renderStatutCell(appointment)}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HomePat;